// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { EventSource, EventType } from '@shared/commons/cache/Event/EventConstants';
import { Resources } from '@shared/localizations/Resources';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import TerceraBaseWindowTemplate from '@front/templates/TerceraBaseWindowTemplate.html';
import TerceraTicketScreenTemplate from '@front/templates/TerceraTicketScreenTemplate.html';
import { TicketData } from '../UtilsClasses/TicketData';
import { TerceraWindowBase } from './TerceraWindowBase';
import { WDSettings } from '../settings/WDGeneralSettings';
export class TerceraTicketScreen extends TerceraWindowBase {
    constructor() {
        super();
        this.onShowNextTimeChanged = (event) => {
            void this.set('checked', event.currentTarget.checked);
        };
    }
    getType() {
        return 'TerceraTicketScreen';
    }
    oncomplete() {
        super.oncomplete();
        this.observe('checked', function (newVal) {
            WDSettings.openDialTicketsOnWorkspace = newVal;
        }, { init: false });
        WDSettings.settingsChanged.Subscribe(this.updateChecked, this);
        this.addScrollToContainer('.js-win-innerContainer');
    }
    dispose() {
        WDSettings.settingsChanged.UnSubscribe(this.updateChecked, this);
        const index = TerceraTicketScreen.ScreensSet.indexOf(this);
        if (index != -1) {
            TerceraTicketScreen.ScreensSet.splice(index, 1);
        }
        super.dispose();
    }
    updateChecked() {
        void this.set('checked', WDSettings.openDialTicketsOnWorkspace);
    }
    // TODO. UGLY. Refactor.
    static show(ticket) {
        const screen = new TerceraTicketScreen();
        const visibleFooter = ticket.isTrade;
        void screen.set('header', ticket.screenHeader || ticket.header);
        if (ticket.sortedEntries.length === 1) {
            const singleText = ticket.text || ticket.sortedEntries[0].text || ticket.sortedEntries[0].caption;
            void screen.set('singleRowText', singleText);
        }
        else {
            void screen.set('entries', ticket.sortedEntries);
        }
        void screen.set({
            checked: WDSettings.openDialTicketsOnWorkspace,
            showFooter: visibleFooter,
            text: Resources.getResource('general.messageBox.showNextTime')
        });
        screen.on('complete', function () {
            screen.center();
            if (TerceraTicketScreen.ScreensSet.length > 1) {
                const prew = TerceraTicketScreen.ScreensSet[TerceraTicketScreen.ScreensSet.length - 2];
                let l = prew.get('left');
                let t = prew.get('top');
                if (MainWindowManager.MainWindow.height - t < 400 || MainWindowManager.MainWindow.width - l < 400) {
                    t = l = 50;
                }
                void this.set({ left: l + 25, top: t + 25 });
            }
        });
        screen.gotFocus();
        TerceraTicketScreen.ScreensSet.push(screen);
        MainWindowManager.AddControl(screen);
    }
    // #region New Direct Methods
    static TicketFromEvent(ev) {
        const reportLocKey = 'reports.' + ev.Action;
        const title = Resources.IsResourcePresent(reportLocKey)
            ? Resources.getResource(reportLocKey)
            : Resources.getResource(ev.Action);
        const entries = [];
        const descriptionItems = ev.DescriptionItems;
        const len = descriptionItems.length;
        for (let i = 0; i < len; i++) {
            const item = descriptionItems[i];
            entries.push({
                caption: item.Header,
                text: item.Value
            });
        }
        const ticket = new TicketData();
        ticket.header = title;
        ticket.sortedEntries = entries;
        ticket.eventSource = ev.Source;
        // #121757
        if (ev.EventType === EventType.Trading &&
            ev.Source !== EventSource.Refused &&
            ev.Source !== EventSource.MarginCall) {
            ticket.isTrade = true;
        }
        return ticket;
    }
}
TerceraTicketScreen.ScreensSet = [];
TerceraWindowBase.extendWith(TerceraTicketScreen, {
    template: TerceraBaseWindowTemplate,
    data: function () {
        return {
            resizable: false,
            showFooter: false,
            entries: []
        };
    },
    partials: {
        bodyPartial: TerceraTicketScreenTemplate
    }
});
